export const IDLE_LOGOUT_OPTION_NONE = 'none';

export const IDLE_LOGOUT_OPTIONS = [
  { label: 'None', value: IDLE_LOGOUT_OPTION_NONE },
  { label: '15 Minutes', value: '00:15:00' },
  { label: '30 Minutes', value: '00:30:00' },
  { label: '1 Hour', value: '01:00:00' },
] as const;

export type IdleLogoutOptionValue = (typeof IDLE_LOGOUT_OPTIONS)[number]['value'];

const ISO_DURATION_REGEX = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/i;
const TIMESPAN_REGEX = /^(?:(\d+)\.)?(\d{1,2}):(\d{2}):(\d{2})(?:\.\d+)?$/;

export function getIdleLogoutSelectValue(duration: string | null | undefined): IdleLogoutOptionValue {
  return IDLE_LOGOUT_OPTIONS.some((option) => option.value === duration) ? (duration as IdleLogoutOptionValue) : IDLE_LOGOUT_OPTION_NONE;
}

export function getIdleLogoutTimespan(value: IdleLogoutOptionValue): string | null {
  return value === IDLE_LOGOUT_OPTION_NONE ? null : value;
}

export function getIdleLogoutLabel(value: IdleLogoutOptionValue): string {
  return IDLE_LOGOUT_OPTIONS.find((option) => option.value === value)?.label ?? 'None';
}

export function getIdleLogoutMilliseconds(duration: string | null | undefined): number | null {
  if (!duration || duration === IDLE_LOGOUT_OPTION_NONE) {
    return null;
  }

  const isoMatch = duration.match(ISO_DURATION_REGEX);

  if (isoMatch) {
    const [, hours = '0', minutes = '0', seconds = '0'] = isoMatch;

    return (Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds)) * 1000;
  }

  const timespanMatch = duration.match(TIMESPAN_REGEX);

  if (!timespanMatch) {
    return null;
  }

  const [, days = '0', hours = '0', minutes = '0', seconds = '0'] = timespanMatch;

  return ((Number(days) * 24 + Number(hours)) * 60 * 60 + Number(minutes) * 60 + Number(seconds)) * 1000;
}
